import '../../styles-new/pages/currencies-page.scss';

import { currenciesDateSelector } from '../components/currencies/dateSelector';

const url = new URL(window.location.href);
url.searchParams.delete('bank');
window.history.pushState({}, '', url);

currenciesDateSelector();

// Change tabs section
///////////////////////////////////////////////////////

const [
  tabWithRatesInternational,
  tabWithRatesGov] =
  [document.querySelector('.currencies__rates_tabs span[data-tab="international"]'),
  document.querySelector('.currencies__rates_tabs span[data-tab="govBank"]')];

const [
  tableWithRatesInternational,
  tableWithRatesGov] =
  [document.querySelector('.currencies__rates table[data-tab="international"]'),
  document.querySelector('.currencies__rates table[data-tab="govBank"]')];


tabWithRatesInternational.addEventListener('click', () => {
  tabWithRatesInternational.classList.add('tabs__item_active');
  tabWithRatesGov.classList.remove('tabs__item_active');

  tableWithRatesInternational.classList.remove('hidden');
  tableWithRatesGov.classList.add('hidden');
});

tabWithRatesGov.addEventListener('click', () => {
  tabWithRatesGov.classList.add('tabs__item_active');
  tabWithRatesInternational.classList.remove('tabs__item_active');

  tableWithRatesGov.classList.remove('hidden');
  tableWithRatesInternational.classList.add('hidden');
});
